const linkGroups = [
  {
    title: "サービス",
    links: [
      { label: "不用品回収", href: "/fuyouhin-kaisyu" },
      { label: "遺品整理", href: "/ihin-seiri" },
      { label: "ゴミ屋敷清掃", href: "/gomi-yashiki" },
      { label: "残置物撤去", href: "#services" },
      { label: "産廃回収", href: "#services" },
    ],
  },
  {
    title: "コンテンツ",
    links: [
      { label: "選ばれる理由", href: "#reasons" },
      { label: "料金目安", href: "#pricing" },
      { label: "作業の流れ", href: "#flow" },
      { label: "作業事例", href: "#cases" },
      { label: "よくある質問", href: "#faq" },
    ],
  },
  {
    title: "会社情報",
    links: [
      { label: "会社概要", href: "#company" },
      { label: "お問い合わせ", href: "#contact" },
    ],
  },
];

const areas = ["京都市"];

export default function Footer({ linkPrefix = "" }: { linkPrefix?: string }) {
  return (
    <footer className="w-full bg-secondary-900 text-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-3 mb-5">
              <div className="w-11 h-11 rounded-md bg-primary-500 flex items-center justify-center">
                <i className="ri-truck-line text-background-50 text-xl"></i>
              </div>
              <div className="leading-tight">
                <div className="font-bold text-lg text-background-50 whitespace-nowrap">
                  京都ゴミ処分センター
                </div>
              </div>
            </div>
            <p className="text-background-100/80 text-sm leading-relaxed mb-5">
              京都府全域を対応エリアとする、不用品回収・遺品整理・ゴミ屋敷清掃・残置物撤去・産廃回収の専門会社です。即日対応・丁寧作業・法人対応。
            </p>
            <div className="space-y-2 text-sm text-background-100/85">
              <p className="flex items-center gap-2">
                <i className="ri-map-pin-line text-primary-400"></i>
                京都府京都市伏見区竹田西小屋ノ内町13
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-phone-line text-primary-400"></i>
                0120-02-4747
              </p>
              <p className="flex items-center gap-2">
                <i className="ri-time-line text-primary-400"></i>
                9:00〜17:00 / 年中無休
              </p>
            </div>
          </div>

          <div className="lg:col-span-5 grid grid-cols-2 md:grid-cols-3 gap-8">
            {linkGroups.map((g) => (
              <div key={g.title}>
                <h4 className="text-background-50 font-bold text-sm mb-4 tracking-wider">
                  {g.title}
                </h4>
                <ul className="space-y-2.5">
                  {g.links.map((l) => (
                    <li key={l.label}>
                      <a
                        href={l.href.startsWith("#") ? `${linkPrefix}${l.href}` : l.href}
                        className="text-background-100/75 hover:text-primary-300 text-sm whitespace-nowrap cursor-pointer transition-colors"
                      >
                        {l.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="lg:col-span-3">
            <h4 className="text-background-50 font-bold text-sm mb-4 tracking-wider">
              対応エリア（京都市）
            </h4>
            <div className="flex flex-wrap gap-1.5">
              {areas.map((a) => (
                <span
                  key={a}
                  className="px-2.5 py-1 rounded-full bg-secondary-800 text-background-100/80 text-[11px] whitespace-nowrap"
                >
                  {a}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="max-w-7xl mx-auto px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/70">
          <p>© 2026 京都ゴミ処分センター All rights reserved.</p>
          <p className="tracking-wider">
            京都 不用品回収 / 京都 遺品整理 / 京都 ゴミ屋敷清掃
          </p>
        </div>
      </div>
    </footer>
  );
}